<script lang="ts">
    import { onMount } from 'svelte'
    import Zframe from '../../_common/z/zframe.svelte'
    import { UserNotifications, UserNotificationsEnum } from '../../../modules/usersApi/users/user-notification'
    import Content from '../../_common/content.svelte'
    import RequestPushNotification from '../../_common/request-push-notification.svelte'

    let notifications: UserNotifications = null
    async function load() {
        const user = await window.api.users.users.getOne(window.store.token.userId)
        window.log('UserNotifConfig: User Object', null, user)
        notifications = user.notifications || new UserNotifications()
        window.log('UserNotifConfig: User Notification Configs', null, notifications)
    }

    async function upsertNotifications() {
        notifications = await window.api.users.users.upsertNotifications(notifications)
        //window.alert('Configurações de notificação atualizadas com sucesso.')
    }

    let granted = false
    let checked = false

    onMount(async () => {
        await load()
    })

    function onPermission(ev) {
        window.log('UserNotifConfig: permission changed received from permission component: ' + ev.detail, null, ev.detail)
        granted = ev.detail === 'granted'
        checked = true
    }

    async function testLocalPushNotification() {
        // o timeout é para dar tempo de minimizar o app, se necessário...
        setTimeout(async () => {
            window.log('UserNotifConfig: local test - calling Utils.showNotification()...')
            await window.api.utils.utils.showNotification('Notificação local de testes', 'Agora: ' + new Date().toLocaleString())
            window.log('UserNotifConfig: local test - Utils.showNotification() called.')
        }, 3000)
    }
    async function testServerNotification() {
        setTimeout(async () => {
            try {
                window.log('UserNotifConfig: online test - devices.sendPushNotification()...')
                const result = await window.api.users.devices.sendPushNotification({
                    message: 'Teste de notificação online (mensagem)',
                    source: UserNotificationsEnum.direct,
                    title: 'Teste de notificação online (título)',
                    data: null,
                    icon: null,
                    image: null,
                })
                window.log('UserNotifConfig: online test - devices.sendPushNotification()...', null, result)
                window.alert('Status: ' + result.success)
            } catch (error) {
                window.error(error)
            }
        }, 3000)
    }
    async function requestPushNotificationPermission() {
        window.log('UserNotifConfig: Calling Utils.requestPushNotificationPermission()...')
        await window.api.utils.utils.requestPushNotificationPermission()
        window.log('UserNotifConfig: Utils.requestPushNotificationPermission() called.')
    }

    function goURL() {
        let url = prompt('Informe a URL', 'https://')
        if (!url || url.length <= 10) return
        location.href = url
    }
</script>

{#if notifications}
    <Content>
        {#if !granted}
            <div class="alert alert-warning">
                <div class="alert_label">
                    {#if checked}
                        Você ainda não autorizou as notificações neste dispositivo.
                    {:else}
                        Verificando permissões para notificação...
                    {/if}
                </div>
                <RequestPushNotification on:permission={onPermission} />
            </div>
        {:else if checked}
            <div class="alert alert-success mt-3">Permissões ativas neste dispositivo.</div>
        {/if}
        <div class="config-box mt-3 text-muted">
            As configurações abaixo somente surtem efeito para o usuário atual: {window.store.user?.userName || ''}<br />
            Para receber notificações pelo seu celular:
            <ol>
                <li>Acesse o Zandu pelo celular</li>
                <li>Volte nesta tela (menu Conta &gt; Notificações)</li>
                <li>Clique em 'Ativar Notificações' (caso o botão não apareça provavelmente elas já estão ligadas)</li>
            </ol>
        </div>
        <Zframe title="Agenda" class="mt-3">
            <div class="grid-form">
                <div class="row">
                    <div class="col mt-1">
                        <div class="form-check form-switch">
                            <input
                                class="form-check-input"
                                bind:checked={notifications.scheduler_status_compareceu}
                                type="checkbox"
                                role="switch"
                                id="scheduler_status_compareceu"
                                on:change={upsertNotifications}
                            />
                            <label class="form-check-label" for="scheduler_status_compareceu">Ao mudar status para compareceu</label>
                        </div>
                        <div class="text-muted">
                            Uma notificação será enviada quando o status de um agendamento mudar para 'compareceu'.
                            <br />
                            A notificação somente será enviada se a mudança de status ocorrer próxima do horário do agendamento.
                            <br />
                            A notificação será enviada apenas se você for o usuário que realizará o atendimento.
                        </div>
                    </div>
                </div>
            </div>
        </Zframe>
        <Zframe title="Pipeline" class="mt-3">
            <div class="grid-form">
                <div class="row">
                    <div class="col mt-1">
                        <div class="form-check form-switch">
                            <input
                                class="form-check-input"
                                bind:checked={notifications.pipeline_integration_new_card}
                                type="checkbox"
                                role="switch"
                                id="pipeline_integration_new_card"
                                on:change={upsertNotifications}
                            />
                            <label class="form-check-label" for="pipeline_integration_new_card">Ao criar um novo cartão via integração externa</label>
                        </div>
                        <div class="text-muted">
                            Uma notificação será enviada sempre que um novo cartão foi adicionado para você no pipeline através da integração externa.
                        </div>
                    </div>
                </div>
            </div>
        </Zframe>
        {#if window.beta}
            <Zframe title="Testar notificações" class="mt-3">
                <div class="row">
                    <div class="col">
                        <button on:click={requestPushNotificationPermission}>Ativar notificações</button>
                        <button on:click={testLocalPushNotification}>Testar notificação local</button>
                        <button on:click={testServerNotification}>Testar notificação online</button>
                        <button on:click={goURL}>Abrir URL</button>
                    </div>
                </div>
            </Zframe>
        {/if}
    </Content>
{/if}

<style>
    .alert {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .alert_label {
        padding-right: 8px;
    }

    @media (max-width: 900px) {
        .alert {
            flex-direction: column;
        }
        .alert_label {
            padding-bottom: 8px;
        }
    }
</style>
